import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useLayoutEffect, useState } from 'react';
import Toggle, { Size } from '@jetbrains/ring-ui/components/toggle/toggle';
import Input from '@jetbrains/ring-ui/components/input/input';
import classNames from 'classnames';
import { isNil } from 'lodash';
import NavigationLink from '@common/navigation/navigation-link';
import { ExternalLinks } from '@common/constants/constants';
import { assignTestId } from '@common/infra/tests/assign-test-id';
import styles from './limit-assigment-editor.css';
const DEFAULT_LIMIT = 250;
export function LimitAssigmentEditor(props) {
    const { readonly, limit, onLimitChange, toggleText, limitNotice, className, limitEntity = 'users' } = props;
    const [inputValue, setInputValue] = useState(isNil(limit) || limit === 'unlimited' ? '' : limit.toString());
    const [error, setError] = useState();
    const [unlimited, setUnlimited] = useState(limit === 'unlimited');
    // in case if value was changed from outside
    useLayoutEffect(() => {
        setUnlimited(limit === 'unlimited');
        if (limit !== 'unlimited') {
            setInputValue((limit || '').toString());
        }
    }, [limit]);
    const handleInputChange = useCallback((e) => {
        setInputValue(e.target.value);
        const newLimit = parseInt(e.target.value || '') || 0;
        onLimitChange(newLimit);
        setError(newLimit > 0 ? undefined : 'User limit should be a positive number');
    }, [onLimitChange]);
    const handleToggleChange = useCallback((e) => {
        setUnlimited(e.target.checked);
        if (e.target.checked) {
            onLimitChange('unlimited');
        }
        if (!e.target.checked) {
            if (inputValue.length) {
                onLimitChange(parseInt(inputValue));
            }
            else {
                onLimitChange(DEFAULT_LIMIT);
            }
        }
    }, [onLimitChange, inputValue, setUnlimited]);
    return (_jsxs("div", { className: className, ...assignTestId('limit-editor'), children: [readonly ? (_jsx("p", { className: styles.label, children: "Limit" })) : (_jsx(Toggle, { className: styles.toggle, checked: unlimited, onChange: handleToggleChange, size: Size.Size16, ...assignTestId('limit-toggle'), children: toggleText })), !unlimited && (_jsxs("div", { className: classNames(styles.inputWrapper, { [styles.readOnly]: readonly }), children: [_jsx(Input, { className: styles.input, name: "assignedUsersLimit", type: "number", min: 1, value: inputValue, onChange: handleInputChange, disabled: readonly, error: error, ...assignTestId('limit-input') }), readonly && (_jsxs("p", { className: styles.needMore, children: ["To request additional trial ", limitEntity, ", please", ' ', _jsx(NavigationLink, { href: ExternalLinks.JB_SALES, children: "contact us." })] }))] })), !readonly && limitNotice && _jsx("p", { className: styles.limitNotice, children: limitNotice })] }));
}
